import { getIPLocation } from './getIPLocation';

// Resolves the visitor's IP-derived timezone/location during initApp(), before
// any page-level data (World page's publisher fetches) is pulled. Unlike
// admin-v4-ui's getCountryInfo, there's no already-loaded publisher/profile
// timezone to prefer at this point in EcalWorld's init flow — this runs before
// session/profile resolution, so the IP-derived value is all there is.
async function getCountryInfo() {
    this.countryInfo = await getIPLocation();
}

export default getCountryInfo;
